var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutterwaveWord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 916.7 144.7",
    width: 100,
    height: 24,
    style: {
      enableBackground: "new 0 0 916.7 144.7"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#2A3362;}\n\t.st1{fill:#009A46;}\n\t.st2{fill:#FF5805;}\n\t.st3{fill:#F5AFCB;}\n\t.st4{fill:#FF9B00;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.5,
    y: 33.8,
    className: "st0",
    width: 16.1,
    height: 82.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359,87.3c0,11.4-7.4,16.6-17.2,16.6s-16.4-5.1-16.4-16V58.3h-16.1v33.3c0,16.6,10.4,26.3,27.7,26.3 c10.9,0,16.9-4,21-8.5h0.9l1.4,7.4h14.8V58.3H359V87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517,105.2c-11.8,0-18.4-5.4-19.5-13.2h51.1c0.2-1.6,0.4-3.3,0.3-4.9c-0.1-21-16-29.9-33-29.9 c-19.7,0-34.6,11.8-34.6,30.8c0,18.1,14.2,29.9,35.6,29.9c17.9,0,29.8-7.9,32.2-20.1h-15.9C531.4,102.6,525.7,105.2,517,105.2z  M516,69.9c10.3,0,16.2,4.6,17.2,11h-35.3C499.4,74.7,505.4,69.9,516,69.9L516,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576.4,66.7h-1l-1.5-8.4h-14.6v58.4h16.1V91.6c0-11.3,6.5-17.6,18.7-17.6c2.2,0,4.4,0.2,6.6,0.6V58.3h-2.2 C587.6,58.3,581,60.6,576.4,66.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "679.7,98.5 678.8,98.5 665,62 648.4,62 634.9,98.4 633.8,98.4 621,58.3 605,58.3 624.7,116.7  642.2,116.7 656.2,79.5 657.2,79.5 671,116.7 688.6,116.7 708.3,58.3 692.3,58.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.4,99.7V80.2c0-15.9-13.4-23-30.1-23c-17.7,0-28.8,8.4-30.3,21h16.1c1.2-5.5,5.8-8.5,14.2-8.5 s14,3.2,14,9.6v1.5l-26.3,2c-12.1,0.9-21,6.3-21,17.8c0,11.8,10.2,17.4,25.1,17.4c12.1,0,19.4-3.4,23.9-8.4h0.8 c2.5,5.7,7.7,7.3,13.2,7.3h6.8v-11.9h-1.5C774,104.8,772.4,103.2,772.4,99.7z M756.3,93.5c0,9.2-11,12.3-20.4,12.3 c-6.4,0-10.6-1.6-10.6-6.1c0-4,3.6-5.9,9-6.4l22.1-1.6L756.3,93.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "832,58.3 813.2,100.6 812.2,100.6 793.1,58.3 775.7,58.3 802.9,116.7 822.2,116.7 849.3,58.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M900.8,97.8c-2,4.8-7.7,7.4-16.3,7.4c-11.8,0-18.4-5.4-19.5-13.2h51.1c0.2-1.6,0.4-3.3,0.3-4.9 c-0.1-21-16-29.9-33-29.9c-19.7,0-34.5,11.8-34.5,30.8c0,18.1,14.2,29.9,35.6,29.9c17.9,0,29.8-7.9,32.2-20.1H900.8z M883.4,69.9 c10.3,0,16.2,4.6,17.2,11h-35.3C866.8,74.7,872.7,69.9,883.4,69.9L883.4,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.4,54c0-5.1,3.6-7.3,8.3-7.3c2.2,0,4.3,0.3,6.4,0.9l2.7-11.7c-3.9-1.4-8-2.1-12.1-2.1 c-11.9,0-21.5,6.3-21.5,19.4v5.1h-13.9v12.8h13.9v45.6h16.2V71.1h18.2V58.3h-18.2V54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.8,41.9h-15l-0.8,16.5h-12.7v12.8h12.4v28.8c0,9.8,5,18,20,18c3.9,0,7.8-0.4,11.6-1.3v-12.3 c-2.2,0.5-4.4,0.8-6.7,0.8c-8,0-8.8-4.6-8.8-8.1v-26h16V58.3h-16V41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.4,41.9h-14.9l-0.8,16.5h-12.7v12.8h12.4v28.8c0,9.8,5,18,20,18c3.9,0,7.7-0.5,11.5-1.3v-12.3 c-2.2,0.5-4.4,0.8-6.7,0.8c-8,0-8.8-4.6-8.8-8.1v-26h16V58.3h-16.1V41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,31.6c0-9.4,2.7-17.4,8.5-23.1l10,10C7.4,29.6,17.1,64.1,48.8,95.8s66.2,41.4,77.3,30.3l10,10 c-18.8,18.8-61.5,5.4-97.3-30.3C14,80.9,0,52.8,0,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.1,144.7c-9.4,0-17.4-2.7-23.1-8.5l10-10c11.1,11.1,45.6,1.4,77.3-30.3s41.4-66.2,30.3-77.3l10-10 c18.8,18.8,5.4,61.5-30.3,97.3C112.4,130.7,84.2,144.7,63.1,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.5,91.6c-6.1-17.5-18.5-36.2-34.9-52.6C69.8,3.2,27.1-10.1,8.3,8.6l0,0C7,10,8.2,13.3,10.9,16 s6.1,3.9,7.4,2.6c11.1-11.1,45.6-1.4,77.3,30.3c15,15,26.2,31.8,31.6,47.3c4.7,13.6,4.3,24.6-1.2,30.1l0,0 c-1.3,1.3-0.2,4.6,2.6,7.4s6.1,3.9,7.4,2.6C145.6,126.6,147.2,110.7,140.5,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.5,8.6C157.9-1,142-2.6,122.9,4c-17.5,6.1-36.2,18.5-52.6,34.9c-35.8,35.8-49.1,78.5-30.3,97.3l0,0 c1.3,1.3,4.7,0.2,7.4-2.6s3.9-6.1,2.6-7.4c-11.1-11.1-1.4-45.6,30.3-77.3c15-15,31.8-26.2,47.2-31.6c13.6-4.7,24.6-4.3,30.1,1.2 l0,0c1.3,1.3,4.6,0.2,7.4-2.6S168.9,10,167.5,8.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterwaveWord);
export default __webpack_public_path__ + "static/media/flutterwave_word.74ef80f68b96509c594dbaab21c71a04.svg";
export { ForwardRef as ReactComponent };